import { useState, useEffect } from "react";
import axios from "axios";
import { FaPlay } from "react-icons/fa";
import { Loading } from "../Other/Loading";

const LifeAtSmik = () => {
  const [lifeAtSmik, setLifeAtSmik] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/careers`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setLifeAtSmik(events.LifeAtsmik); // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);


  useEffect(() => {
    if (showVideo) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [showVideo]);

  if (!lifeAtSmik) return <p className="text-center text-white"><Loading /></p>;

  return (
    <div className="flex flex-col items-center p-6">
      {/* Title */}
      <h2 className="text-2xl md:text-4xl font-bold text-black mb-6 py-4 md:py-8 text-center">
        {lifeAtSmik.title}
      </h2>

      {/* Main Container */}
      <div
        className="p-6 rounded-lg shadow-lg flex justify-center md:justify-end items-center max-w-4xl w-full"
        style={{
          backgroundImage: `url(${lifeAtSmik.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "400px"
        }}
      >
        {/* Right-Side Content Box */}
        <div className="p-6 rounded-lg max-w-md w-full text-center md:text-left relative">
          <p className="text-xl md:text-4xl font-bold">{lifeAtSmik.title}</p>
          <p className="text-gray-800 mb-4 text-sm md:text-lg">{lifeAtSmik.description}</p>

          {/* Play Button - Centered on small screens */}
          <div className="flex justify-center md:justify-start">
            <button
              onClick={() => setShowVideo(true)}
              className="mt-4 md:mt-6 flex items-center gap-2 bg-blue-500 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-600 transition text-sm md:text-base"
            >
              <FaPlay className="text-white text-lg" />

            </button>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {showVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-2xl w-full relative">
            {/* Close Button */}
            <button
              onClick={() => setShowVideo(false)}
              className="!absolute top-2 right-2 p-2 rounded-full bg-black bg-opacity-50 text-white"
            >
              ✕
            </button>

            {/* Embedded YouTube Video */}
            <div className="relative w-full h-0 pb-[56.25%]">
              <iframe
                className="!absolute top-0 left-0 w-full h-full"
                src={lifeAtSmik.videoUrl} // Ensure this is a valid YouTube embed link
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LifeAtSmik;
